import React from "react";
import "./About.css";
import { Link } from "react-router-dom";
import founder from './assets/Saumya_didi.png';

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

const AboutUs = () => {
  return (
    <div className="about-us">
      <header className="header">
        <h1>
          Our <span className="highlight">Story</span>
        </h1>
        <b>
          Discover the philosophy behind Liv Minus - where simplicity meets
          sustainable luxury
        </b>
      </header>

      <section className="hero-video">
        <video className="video" autoPlay muted loop>
          <source src={"/assets/video/Bannervideo.mp4"} type="video/mp4" />
        </video>
      </section>
      <div class="form-divider-line"></div>
      <section className="content-About">
       
        <div className="text-section">
          <h3>Our Beginning</h3>
          <p>
            Every morning, I stood in front of a full wardrobe - and felt like I
            had nothing to wear.
          </p>
          <p>
            I was just tired - of clothes that looked loud but said nothing. Of
            buying things I never truly wore. of fabrics that felt synthetic on
            my skin,and styles that didn't feel like me.
          </p>
          <p>
            Then life slowed down. I spent time in Mysore, surrounded by
            silence, trees, and the kind of people who live with intention. My
            wardrobe shifted beofre the rest of me did.
          </p>
        </div>
        <div className="image-section">
        <section className="founder">
          <img src={founder} alt="Saumya Singh - Founder" />
          <h3>Saumya Singh</h3>
          <p>Founder, Liv Minus</p>
          <p className="founder-quote">
            "If you're someone who values ease over excess… You'll probably feel at home here."
          </p>
        </section>
        </div>
      </section>

      <section className="content-About reverse">
        <div className="text-section">
          <h3>The Philosophy</h3>
          <p>
            That's when the idea for Liv Minus took shape. Not as a business,
            but as a way of living.
          </p>
          <p>
            Our clothes are built on that idea: Classics. Clean lines. Natural,
            breathable fabrics. Quiet details.
          </p>
          <p>
            Nothing performative. Nothing you'll wear again and again - to work,
            to travel,to just be.{" "}
          </p>
        </div>
        <div className="image-section">
          <video className="video2" autoPlay muted loop>
            <source
              src={"/assets/video/EcoPrintWebsite.mp4"}
              type="video/mp4"
            /> 
          </video>
        </div>
      </section>
      <div class="form-divider-line"></div>
      <section className="materials">
        <h2>
          Our Materials & <span className="highlight">Process</span>
        </h2>
        <div className="material-grid">
          <div className="material-item">
            <h3>Natural Fabrics</h3>
            <p>
              We use handwoven fabrics like bamboo cotton, kala cotton, and
              linen for breathability and sustainability.
            </p>
          </div>
          <div className="material-item">
            <h3>Non-Toxic Dyes</h3>
            <p>
              All our fabrics are colored with natural dyes that are safe for
              both you and the environment.
            </p>
          </div>
          <div className="material-item">
            <h3>Slow Processes</h3>
            <p>
              We prioritize quality over quantity, taking the time needed to
              craft each piece with care.
            </p>
          </div>
        </div>
      </section>

      <section className="testimonials">
        <h2>
          What <span className="highlight">We</span> Believe
        </h2>
        <div className="testimonial-card">
          <p>
            "It's not about labels or loud statements. The luxury we believe in
            is quieter."
          </p>
        </div>
        <div className="testimonial-card">
          <p>
            "This isn't fashion. It's just clothing - made well, made mindfully,
            and made to stay with you."
          </p>
        </div>
      </section>

      {/* <section className="founder">
        <p>
          "If you're someone who values ease over excess… You'll probably feel
          at home here."
        </p>
        <Link to="/ExploreAll" onClick={scrollToTop} className="explore-button">
          Explore Our Collection
        </Link>
      </section> */}
    </div>
  );
};

export default AboutUs;
